import { Alert, Avatar, Card, Col, Divider, Flex, Row, Typography } from 'antd'

import React from 'react'

import { translate } from '~/utils/locale'

import { useListParentClients } from '~/hooks/Clients/useListParentCustomer'

import { useClients } from '~/hooks/Clients/useClients'
import NumberFormat from 'react-number-format'
import CurrencyFormatter from '~/components/DataManipulation/Misc/CurrencyFormater'
import ModalParentClient from '../Modal'
import {
  AuditOutlined,
  BankOutlined,
  CarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  HomeOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  PushpinOutlined,
  ShopOutlined,
  UserOutlined,
} from '@ant-design/icons'

const DetailsParentCustomerInClient: React.FC = () => {
  const { clients } = useClients()
  const { parentClients } = useListParentClients()

  const { Title, Text } = Typography

  const filterParentClient = parentClients?.filter(
    (p) => p._id === clients?.parent_cnpj,
  )
  const data = filterParentClient?.[0]

  return (
    <>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            Cliente Principal
          </Title>
        }
        style={{
          display: 'inline-block',
          width: '100%',
        }}
        extra={<ModalParentClient />}
      >
        {data ? (
          <>
            <Row>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <AuditOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Razão Social / Nome
                    </Title>
                    {data?.companyName ? (
                      <Text>{data?.companyName}</Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <ShopOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Nome Fantasia
                    </Title>
                    {data?.fantasyName ? (
                      <Text>{data?.fantasyName}</Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>

            <Row style={{ marginTop: 14 }}>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <IdcardOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      CNPJ
                    </Title>
                    {data?.cnpj ? (
                      <Text>
                        <NumberFormat
                          value={data?.cnpj}
                          displayType="text"
                          format="##.###.###/####-##"
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <IdcardOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      CPF
                    </Title>
                    {data?.cpf ? (
                      <Text>
                        <NumberFormat
                          value={data?.cpf}
                          displayType="text"
                          format="###.###.###-##"
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>

            <Row style={{ marginTop: 14 }}>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <UserOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Inscrição Estadual
                    </Title>
                    {data?.state_registration ? (
                      <Text>{data?.state_registration}</Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <MailOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Inscrição Municipal
                    </Title>
                    {data?.municipal_registration ? (
                      <Text>{data?.municipal_registration}</Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>

            <Divider style={{ margin: '14px 0' }} />
            <Title level={5}>Dados Pessoais do Cliente</Title>
            <Row style={{ marginTop: 10 }}>
              <Col span={8}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <UserOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Nome
                    </Title>
                    {data?.contact?.name ? (
                      <Text>{data?.contact?.name}</Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={8}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <MailOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Email
                    </Title>
                    {data?.contact?.email ? (
                      <Text>{data?.contact?.email}</Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={8}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <PhoneOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Telefone
                    </Title>
                    {data?.contact?.phone ? (
                      <Text>
                        <NumberFormat
                          value={data?.contact.phone}
                          displayType="text"
                          format="(##) #####-####"
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>
          </>
        ) : (
          <Alert
            message="Nenhum cliente principal adicionado."
            type="info"
            showIcon
          />
        )}
      </Card>

      {data ? (
        <>
          <Card
            bordered={false}
            title={
              <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
                Endereço
              </Title>
            }
            style={{
              display: 'inline-block',
              width: '100%',
              marginTop: 15,
            }}
          >
            <Row gutter={12} style={{ marginTop: 10 }}>
              <Col span={6}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <PushpinOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksTabsDetails.zipcodeText')}
                    </Title>
                    {data?.address.zip_code ? (
                      <Text>{data?.address.zip_code}</Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <HomeOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksTabsDetails.addressText')}
                    </Title>
                    {data?.address ? (
                      <Text>
                        {data?.address.street}, {data?.address.number} -{' '}
                        {data?.address.neighborhood}
                      </Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>
              <Col>
                <Flex gap={8}>
                  <Avatar
                    shape="square"
                    icon={
                      <BankOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksTabsDetails.cityText')}
                    </Title>
                    {data?.address ? (
                      <Text>
                        {data?.address.city} - {data?.address.state}
                      </Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>

            <Row style={{ marginTop: 14 }}>
              <Col span={6}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <PushpinOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('AddressList.complementText')}
                    </Title>
                    {data?.address.complement ? (
                      <Text>{data?.address.complement}</Text>
                    ) : (
                      'Nenhuma informação disponível.'
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>
          </Card>
          <Card
            bordered={false}
            title={
              <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
                Financeiro
              </Title>
            }
            style={{
              display: 'inline-block',
              width: '100%',
              marginTop: 15,
            }}
          >
            <Row>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <DollarOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Valor da Tarefa
                    </Title>
                    {data?.financial?.task_value ? (
                      <Text>
                        <CurrencyFormatter
                          value={data?.financial?.task_value}
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>

            <Row style={{ marginTop: 14 }}>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <ClockCircleOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Quantidade de Horas
                    </Title>
                    {data?.financial?.amount_hours ? (
                      <Text>{data?.financial?.amount_hours} horas</Text>
                    ) : (
                      <Text>Nenhuma quantidade de horas foi fornecida.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <DollarOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Valor Hora Adicional
                    </Title>
                    {data?.financial?.amount_hours_additional ? (
                      <Text>
                        <CurrencyFormatter
                          value={data?.financial?.amount_hours_additional}
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>
            <Row style={{ marginTop: 14 }}>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <CarOutlined style={{ fontSize: 12, color: '#464545' }} />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Quantidade de KM
                    </Title>
                    {data?.financial?.number_km ? (
                      <Text>{data?.financial?.number_km} km</Text>
                    ) : (
                      <Text>Nenhuma quantidade de km foi fornecida.</Text>
                    )}
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <ClockCircleOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      Valor KM Adicional
                    </Title>
                    {data?.financial?.number_km_additional ? (
                      <Text>
                        <CurrencyFormatter
                          value={data?.financial?.number_km_additional}
                        />
                      </Text>
                    ) : (
                      <Text>Nenhuma informação disponível.</Text>
                    )}
                  </div>
                </Flex>
              </Col>
            </Row>
          </Card>
        </>
      ) : (
        ''
      )}
    </>
  )
}

export default DetailsParentCustomerInClient
